<template>
  <div class="container">
    <h2 id="water">5. Hydrology and Water Resources</h2>
    <div class="row">
      <div class="col-sm-12">
        <p>
          The hydrology and water resources section gives an introduction to the hydrological situation in and around the area of interest. Catchment and watersheds have been extracted from the HydroBASINS dataset [<a href="#ref-6">6</a>], and delineated and colored if they flow out of the area of interest in a different location. The river system is extracted from the global river classification (GloRiC) dataset [<a href="#ref-7">7</a>], and locations of dams from the global dams and reservoirs (GRanD) dataset by Global Dam Watch [<a href="#ref-8">8</a>].
        </p>
        <p>
          Subcatchments and upstream area can be selected by hovering over the map, and the locations of dams in the hydrological system have been marked with a red dot <i class="fas fa-circle" style="color:red;font-size:0.8em;"></i>.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <HydrologyMap 
          background="ckg1ah7r023sd19o3uk1tc1yt" 
          source="" 
          title="Hydrological Overview" 
          attribution="Map: Geofolio. Data: HydroBASINS, GLORIC, GRanD. Backgrounds: Mapbox/Openstreetmap Contributors." 
          v-bind:layout="{legendWidth:0, legendCols:2, descriptionWidth:9, order:['legend','description'] }"
          v-bind:location="location" 
          v-bind:factsheet="factsheet"
          v-bind:loaded="loaded">
          <p>
            The hydrological overview map shows catchments and subcatchments from the HydroSHEDS dataset [6], which is derived from the 90m SRTM hydrologically corrected elevation data. Catchments have disctinct colors based on where the outlet crosses the boundary of the selected area of interest. It is likely that catchments with different colors will still merge shortly after leaving the area of interest. 
          </p>
          <p>
            The locations of known dams are marked with <i class="fas fa-circle" style="color:red;font-size:0.8em;"></i> and are based on the Global Rivers and Dams (GRanD) dataset [8]. The river network is from the Global River Classification (GloRiC) dataset [7].
          </p>

        </HydrologyMap>
      </div>
    </div>

  </div>
</template>


<script>
import HydrologyMap from '@/components/factsheet/maps/HydrologyMap.vue'
export default {
    name: 'Hydrology',
    components:{
        HydrologyMap
    },
    props: ['location', 'factsheet', 'loaded'],
    data() {
      return {}
    },
    created() {
    },
    computed: {
    },
    mounted() {
    }
}
</script>

<style>

</style>